// ========================================
// 📄 src/services/dashboardService.js
// ========================================
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
} from "firebase/firestore";
import { db } from "../config/firebase";

export const dashboardService = {
  // Statistiques globales
  async getGlobalStats() {
    try {
      const leadsSnapshot = await getDocs(collection(db, "leads"));
      const leads = leadsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const stats = {
        totalLeads: leads.length,
        newLeads: leads.filter((l) => l.status === "nouveau").length,
        contactedLeads: leads.filter((l) => l.status === "contacté").length,
        qualifiedLeads: leads.filter((l) => l.status === "qualifié").length,
        convertedLeads: leads.filter((l) => l.status === "converti").length,
        lostLeads: leads.filter((l) => l.status === "perdu").length,
      };

      return stats;
    } catch (error) {
      console.error("Error fetching stats:", error);
      return null;
    }
  },

  // Statistiques par commercial
  async getUserStats(userId) {
    try {
      const q = query(
        collection(db, "leads"),
        where("assignedToUserId", "==", userId)
      );
      const snapshot = await getDocs(q);
      const leads = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      return {
        totalLeads: leads.length,
        converted: leads.filter((l) => l.status === "converti").length,
        conversionRate:
          leads.length > 0
            ? (
                (leads.filter((l) => l.status === "converti").length /
                  leads.length) *
                100
              ).toFixed(2)
            : 0,
      };
    } catch (error) {
      console.error("Error fetching user stats:", error);
      return null;
    }
  },

  // Activité récente
  async getRecentActivity(userId, isAdmin, limitCount = 10) {
    try {
      let q;
      if (isAdmin) {
        q = query(
          collection(db, "interactions"),
          orderBy("createdAt", "desc"),
          limit(limitCount)
        );
      } else {
        q = query(
          collection(db, "interactions"),
          where("userId", "==", userId),
          orderBy("createdAt", "desc"),
          limit(limitCount)
        );
      }

      const snapshot = await getDocs(q);
      return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
      console.error("Error fetching recent activity:", error);
      return [];
    }
  },

  // Top performers (pour admin)
  async getTopPerformers() {
    try {
      const usersSnapshot = await getDocs(collection(db, "USERS"));
      const users = usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const performanceData = await Promise.all(
        users
          .filter((u) => u.role === "commercial")
          .map(async (user) => {
            const stats = await this.getUserStats(user.id);
            return {
              userId: user.id,
              name: `${user.firstName} ${user.lastName}`,
              ...stats,
            };
          })
      );

      return performanceData.sort((a, b) => b.converted - a.converted);
    } catch (error) {
      console.error("Error fetching top performers:", error);
      return [];
    }
  },
};
